module.exports = __webpack_public_path__ + "static/media/hotel.59c5f1d6.png";